function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import useStyles from 'isomorphic-style-loader/useStyles';
import Modal from 'components/Modal';
import useEnrollInClinic from 'modules/Patient/partials/EnrollInClinic/useEnrollInClinic';
import { useAction } from 'hooks';
import App from 'modules/App';
import Button from 'components/Form/Button';
import messages from '../../messages';
import * as constants from '../../constants';
import styles from './EnrollInClinicPage.pcss';
const WaitForEnrollInTheClinicRequestAcceptedModal = ({ headerMessage, infoMessage, onClose })=>{
    const openModalId = useSelector(App.selectors.modal);
    const renderContent = ()=>/*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage)),
                /*#__PURE__*/ _jsx("div", {
                    className: "modal__actions",
                    children: /*#__PURE__*/ _jsx(Button, {
                        styleModifier: "primary",
                        labelMessage: messages.buttons.close,
                        className: "btn--block btn--filled",
                        onClick: onClose
                    })
                })
            ]
        });
    return /*#__PURE__*/ _jsx(Modal, {
        modalId: constants.WAIT_FOR_ENROLL_IN_THE_CLINIC_REQUEST_ACCEPTED_MODAL,
        openModalId: openModalId,
        styleModifier: "md",
        headerMessage: headerMessage,
        children: renderContent()
    });
};
const EnrollInClinicPage = ({ onBack })=>{
    useStyles(styles);
    const onClearForm = useAction(App.actions.clearForm, constants.ENROLL_IN_CLINIC_FORM);
    const onCloseModalAction = useAction(App.actions.closeModal);
    let handleSetIsSucceed;
    const onCancel = async ()=>{
        handleSetIsSucceed(false);
        onBack();
    };
    const { isSucceed, setIsSucceed, infoMessages, headerMessages, renderEnrollInClinicForm } = useEnrollInClinic(onCancel);
    handleSetIsSucceed = setIsSucceed;
    const onOpenModal = useAction(App.actions.openModal, constants.WAIT_FOR_ENROLL_IN_THE_CLINIC_REQUEST_ACCEPTED_MODAL);
    const isSucceedRef = useRef(isSucceed);
    useEffect(()=>{
        if (!isSucceedRef.current && isSucceed) {
            onClearForm();
            onOpenModal();
        }
        isSucceedRef.current = isSucceed;
    }, [
        isSucceed
    ]);
    const renderInfo = ()=>/*#__PURE__*/ _jsx("h1", {
            className: "text--base",
            children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessages.provideEnrollCode))
        });
    const onCloseModal = ()=>{
        onCloseModalAction();
        onBack();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            renderInfo(),
            renderEnrollInClinicForm(styles.formContainer),
            /*#__PURE__*/ _jsx(WaitForEnrollInTheClinicRequestAcceptedModal, {
                headerMessage: headerMessages.waitForRequestAccepted,
                infoMessage: infoMessages.waitForRequestAccepted,
                onClose: onCloseModal
            })
        ]
    });
};
export default EnrollInClinicPage;
